export class MockLocalStorage implements Storage {
  store: {
    [key in string]: string;
  } = {};

  clear() {
    for (const key of Object.keys(this.store)) {
      delete this.store[key];
    }
  }

  getItem(key: string) {
    if (!(key in this.store)) {
      return null;
    }
    return this.store[key];
  }

  key(index: number) {
    return Object.keys(this.store)[index] ?? null;
  }

  removeItem(key: string) {
    delete this.store[key];
  }

  setItem(key: string, value: string) {
    this.store[key] = value;
  }

  get length() {
    return Object.keys(this.store).length;
  }
}

export const localStorage = new MockLocalStorage();
